import {useTranslation} from '@/translations/i18n.tsx'
import {PatientStatusFilter} from '@/features/mailer/types'
import {
    StyledSegment,
    StyledSegmentedBar,
    StyledSegmentedCaption,
    StyledSegmentedWrapper
} from '@/features/mailer/components/mailer-segmented/style'

interface MailerPatientStatusSegmentedProps {
    value: PatientStatusFilter
    onChange: (value: PatientStatusFilter) => void
}

export const MailerPatientStatusSegmented = ({value, onChange}: MailerPatientStatusSegmentedProps) => {
    const {t} = useTranslation()

    const options = [
        {value: 'all', label: t('mailer:patient_status_all'), sub: t('mailer:patient_status_all_sub')},
        {value: 'active', label: t('mailer:patient_status_active'), sub: t('mailer:patient_status_active_sub')},
        {value: 'inactive', label: t('mailer:patient_status_inactive'), sub: t('mailer:patient_status_inactive_sub')}
    ] as const

    const activeOption = options.find(option => option.value === value)

    return (
        <StyledSegmentedWrapper>
            <StyledSegmentedBar role="radiogroup" aria-label={t('mailer:patient_status_label')}>
                {options.map((option, index) => (
                    <StyledSegment
                        key={option.value}
                        type="button"
                        role="radio"
                        aria-checked={value === option.value}
                        title={option.sub}
                        $selected={value === option.value}
                        $isFirst={index === 0}
                        onClick={() => onChange(option.value)}
                    >
                        {option.label}
                    </StyledSegment>
                ))}
            </StyledSegmentedBar>
            {activeOption && <StyledSegmentedCaption>{activeOption.sub}</StyledSegmentedCaption>}
        </StyledSegmentedWrapper>
    )
}

MailerPatientStatusSegmented.displayName = 'MailerPatientStatusSegmented'
